<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Daftar Penarikan</h5>
            </template>
            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="9">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Penarikan">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterFromDateTarik" name="filterFromDateTarik"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input
                                    v-model="input.filterToDateTarik" name="filterToDateTarik"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Set Kirim">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterFromDateKirim" name="filterFromDateKirim"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input
                                    v-model="input.filterToDateKirim" name="filterToDateKirim"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                type="search"
                                id="filterNoFaktur"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                Search 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="daftarPenarikan" 
                :fields="fields" 
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data penarikan.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    <p class="mb-0">{{row.item.noFaktur}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.cabang}}</p>
                </template>
                <template v-slot:cell(namaAnggota)="row">
                    <p class="mb-0">{{row.item.namaAnggota}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                </template>
                <template v-slot:cell(barang)="row">
                    <p class="mb-0">{{row.item.jenis}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                </template>
                <template v-slot:cell(tanggalPenarikan)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalPenarikan)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalPenarikan)}}</div>
                </template>
                <template v-slot:cell(tanggalSetKirim)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalSetKirim)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalSetKirim)}}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="dark" v-if="row.item.status == 'SURAT'">SURAT</b-badge>
                    <b-badge variant="warning" v-else-if="row.item.status == 'DI CABANG'">DI CABANG</b-badge>
                    <b-badge variant="primary" v-else>{{ row.item.status }}</b-badge>   
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="gadaiViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">SURAT</h6>
                <p class="smallText mb-0">Surat penarikan sudah disiapkan untuk nomor faktur ini. Menunggu tindak lanjut dari tim penarikan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DI CABANG</h6>
                <p class="smallText mb-0">Kendaraan sudah ditarik dan sedang disimpan di cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">DI PUSAT</h6>
                <p class="smallText mb-0">Kendaraan sudah dikirim dan disimpan di Pusat</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'daftar-penarikan',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterFromDateTarik: null,
                filterToDateTarik: null,
                filterFromDateKirim: null,
                filterToDateKirim: null,
                filterNoFaktur: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur"},
                { key: "namaAnggota", label: "Anggota"},
                { key: "Barang", label: "Barang" },
                { key: "tanggalPenarikan", label: "Tanggal Penarikan"},
                { key: "tanggalSetKirim", label: "Tanggal Set Kirim"},
                { key: "status", label: "Status"},
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [ 
                { id: 0, name: 'Surat' },
                { id: 1, name: 'Di Cabang' },
                { id: 2, name: 'Di Pusat' },
            ],
            daftarPenarikan: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){

            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.cabangId = this.$helper.getCabangId()
            this.query = this.query+"&cabangId="+this.cabangId
            
            let getDaftarPenarikan = this.$axios.get("daftar-penarikan/daftar-cabang/"+this.query).then(response => {
                this.daftarPenarikan = response.data.data
                this.updateTotalItem(response.data.total)
            
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getDaftarPenarikan]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
                this.toggleBusy()
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDaftarPenarikan(){
            this.toggleBusy()
            this.daftarPenarikan = []
            this.cabangId = this.$helper.getCabangId()

            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateTarik)) this.query = this.query + "&filterStartDateTarik=" + this.input.filterFromDateTarik
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDateTarik)) this.query = this.query + "&filterEndDateTarik=" + this.input.filterToDateTarik
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateKirim)) this.query = this.query + "&filterStartDateKirim=" + this.input.filterFromDateKirim
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDateKirim)) this.query = this.query + "&filterEndDateKirim=" + this.input.filterToDateKirim
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.query += "&cabangId="+this.cabangId
            
            this.$axios.get("daftar-penarikan/daftar-cabang/"+this.query).then(response => {
                this.daftarPenarikan = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDaftarPenarikan()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDaftarPenarikan()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterFromDateTarik = null
            this.input.filterToDateTarik = null
            this.input.filterFromDateKirim = null
            this.input.filterToDateKirim = null
            this.input.filterNoFaktur = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDaftarPenarikan()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDateTarik) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateTarik)){
                this.$helper.toastErr(this, "Mohon isi tanggal penarikan mulai dan tanggal penarikan akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDateTarik) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateTarik)){
                this.$helper.toastErr(this, "Mohon isi tanggal penarikan mulai dan tanggal penarikan akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDateTarik) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateTarik)) && (Date.parse(this.input.filterToDateTarik) < Date.parse(this.input.filterFromDateTarik))){
                this.$helper.toastErr(this, "Tanggal penarikan akhir lebih kecil daripada tanggal penarikan mulai!")
            }else if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDateKirim) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateKirim)){
                this.$helper.toastErr(this, "Mohon isi tanggal set kirim mulai dan tanggal set kirim akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDateKirim) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateKirim)){
                this.$helper.toastErr(this, "Mohon isi tanggal set kirim mulai dan tanggal set kirim akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDateKirim) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDateKirim)) && (Date.parse(this.input.filterToDateKirim) < Date.parse(this.input.filterFromDateKirim))){
                this.$helper.toastErr(this, "Tanggal set kirim akhir lebih kecil daripada tanggal set kirim mulai!")
            }else{
                this.getDaftarPenarikan()
            }

        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },
    },

    created(){
        this.init()
    }
}
</script>
